import type { ReferralData } from './data.service';



export const airbnb:ReferralData ={
      title: "Airbnb",
      category: "others,my,sg",
      url: "airbnb-referral-code",
      info: "Open my Airbnb <a href=\"https://www.airbnb.com/rp/lionh112?p=stay&s=76&unique_share_id=4dd9377a-c168-49f4-92f0-afd2d368b06d\" target=\"_blank\">referral link</a> before signing up or booking a stay. No fixed new-user stay credit is publicly confirmed, so check the live Airbnb offer screen.",
      logo: "assets/airbnb-referral.png",
      signup: "https://www.airbnb.com/rp/lionh112?p=stay&s=76&unique_share_id=4dd9377a-c168-49f4-92f0-afd2d368b06d",
      index:"airbnb",
      dateAdded:1567588740,
      tutorial:[],
      isValid: ""
}

export const aeonbank:ReferralData ={
   title: "AEON Bank Referral Code",
   category: "e-wallet,my",
   url: "aeon-bank-referral-code",
   info: "Use my AEON Bank referral code <b>AB240604</b> while opening a Savings Account-i. Eligible new users receive an <b>RM5 cash bonus</b> after successful registration, based on my current July 2026 referral experience. Check the live app offer.",
   logo: "assets/aeon-bank.webp",
   signup: "https://play.google.com/store/apps/details?id=com.personal.adb",
   index:"aeonbank",
   dateAdded:1727184504,
   tutorial:["assets/tutorial/aeon-register-referral-code.jpg","assets/tutorial/aeon-bank-rm5-referral-cash-bonus-july-2026.jpg","assets/tutorial/aeon-register-tnc.jpg","assets/tutorial/aeon-register-my-card.jpg"],
   isValid: ""
}


export const anw:ReferralData ={
   title: "A&W Referral Code",
   category: "dining,my",
   url: "anw-referral-code",
   info: "Register A&W Malaysia with referral code 'A32979' and complete your profile to earn another 50 points, collect points and redeem meal at A&W! Skip the queue and order with the app!",
   logo: "assets/anw.webp",
   signup: "https://play.google.com/store/apps/details?id=com.anw",
   index:"anw",
   dateAdded:1669519353,
   tutorial:["assets/tutorial/anw-rewards.jpg","assets/tutorial/anw-signup-step1.jpg","assets/tutorial/anw-signup-step2.jpg","assets/tutorial/anw-signup-step3.jpg"],
   isValid: ""
}

export const asnb:ReferralData ={
   title: "ASNB Referral Code",
   category: "others,my",
   url: "asnb-referral-code",
   info: "Join ASNB RIA with my referral code <b>2Q8867</b>. I received RM20 Ria deposits from successful referrals on 15 June 2026. Check your live offer before investing.",
   logo: "assets/asnb.webp",
   signup: "https://play.google.com/store/apps/details?id=com.pnb.myASNBmobile&hl=en",
   index:"asnb",
   dateAdded:1745638375,
   tutorial:["assets/tutorial/asnb-ria-referral-reward-received.jpg"],
   isValid: ""
}

export const atlas:ReferralData ={
   title: "Atlas Referral Code",
   category: "others,my",
   url: "atlas-referral-code",
   info: "Use ATLAS referral code <b>B90B4G</b> when joining ATLAS by Bank Muamalat to receive <b>5,000 ATLAS Points</b>, worth about RM5, subject to current requirements.",
   logo: "assets/atlas.webp",
   signup: "https://play.google.com/store/apps/details?id=my.com.muamalat.atlas&hl=en",
   index:"atlas",
   dateAdded:1754123198,
   tutorial:["assets/tutorial/atlas-referral-code.jpg","assets/tutorial/atlas-reward-1.jpg","assets/tutorial/atlas-reward-2.jpg"],
   isValid: ""
}

export const atome:ReferralData ={
   title: "Atome Promo",
   category: "e-wallet,my,shopping",
   url: "atome-promo",
   info: "Open my Atome Malaysia referral link before signup or checkout. The current Atome app screenshots show new-user vouchers up to <b>RM35 off</b> and an Atome Card refer-a-friend points campaign, subject to live app terms.",
   logo: "assets/atome-logo.png",
   signup: "https://www.atome.my/s/Dhyjnoo4v",
   index:"atome",
   dateAdded:1783699200,
   tutorial:["assets/tutorial/atome-refer-a-friend.jpg","assets/tutorial/atome-vouchers.jpg","assets/tutorial/atome-new-user-vouchers.jpg"],
   isValid: ""
}

export const mglobal:ReferralData ={
   title: "M+ Global Invitation Code",
   category: "investment,my",
   url: "mplus-global-invitation-code",
   info: "Join M+ Global with invitation code <b>78935G</b> and check the current new-user rewards for MY, US and HK stock trading.",
   logo: "assets/mglobal.jpg",
   signup: "https://mplusonline.com/campaigns/newuser?lang=en-US&inviteCode=78935G&activityId=86&_scnl=1111738",
   index:"mglobal",
   dateAdded:1781222400,
   tutorial:["assets/tutorial/mglobal-referral-program.jpg","assets/tutorial/mglobal-reward.jpg","assets/tutorial/mglobal-claim-rewards.jpg"],
   isValid: ""
}

export const aunteaJenny:ReferralData ={
   title: "Auntea Jenny Referral Code",
   category: "dining,my",
   url: "auntea-jenny-referral-code",
   info: "Use Auntea Jenny referral code <b>200675</b> in Malaysia when signing up. New users who register with the code get a <b>50% off voucher</b>, subject to the latest app terms.",
   logo: "assets/auntea-jenny-logo.png",
   signup: "https://play.google.com/store/apps/details?id=com.ipskl168.aunteajenny",
   index:"aunteajenny",
   dateAdded:1784332800,
   tutorial:["assets/tutorial/auntea-jenny-signup-referral-code-200675.jpg","assets/tutorial/auntea-jenny-referral-code-200675.jpg","assets/tutorial/auntea-jenny-50-off-voucher.jpg"],
   isValid: ""
}

export const baskinRobin:ReferralData ={
      title: "Baskin Robbins Referral Code",
      index:"baskinrobbins",
      category: "my,dining",
      url: "baskin-robbins-referral-code",
      info: "Use Baskin Robbins referral code <b>86339424</b> in the Malaysia Rewards app. Check the app for current vouchers, points, birthday treats and redemption rules...",
      logo: "assets/baskin-robbins-referral.png",
      signup: "https://play.google.com/store/apps/details?id=com.baskinrobbins.malaysia",
		dateAdded:1608738064,
      tutorial:["assets/tutorial/baskin-robbins-referral-code.png"],
      isValid: ""
}

export const bhp:ReferralData ={
   title: "BHPetrol Referral Code",
   index:"bhpetrol",
   category: "e-wallet,my",
   url: "bhpetrol-referral-code",
   info: "Enter BHPetrol referral code <b>BHP0358387</b> in the BHPetrol eCard app and get 100 ePoints after your qualifying first purchase. Earn and redeem ePoints at participating BHPetrol stations.",
   logo: "assets/bhpetrol.webp",
   signup: "https://play.google.com/store/apps/details?id=com.bzbs.bhpetrol",
   dateAdded:1726130436,
   tutorial:["assets/tutorial/bhp-store-locator.jpg", "assets/tutorial/bhp-reward.jpg"],
   isValid: ""
}

export const bhg:ReferralData ={
   title: "BHG Singapore Referral Code",
   index:"bhg",
   category: "sg,shopping,others",
   url: "bhg-referral-code",
   info: "Join BHG Singapore with my referral code <b>77FDA1</b>. After your qualifying first purchase of at least S$20 nett excluding GST, we will both receive BHG points.",
   logo: "assets/bhg-singapore-logo.jpg",
   signup: "https://bhgsingapore.com.sg/news/whats-new/referral",
   dateAdded:1781524800,
   tutorial:["assets/tutorial/bhg-referral-code-77FDA1.jpg"],
   isValid: ""
}

export const beam:ReferralData ={
   title: "Beam Referral Code",
   category: "my,others",
   url: "beam-referral-code",
   info: "Use Beam referral code <b>AiN7W2</b> in Malaysia to receive RM10 in free Beam ride credits. The referral screen says the code is case-sensitive, and I receive RM10 after your first ride.",
   logo: "assets/beam-logo.svg",
   signup: "https://www.ridebeam.com/download",
   index:"beam",
   dateAdded:1783180800,
   tutorial:["assets/tutorial/beam-referral-code.jpg", "assets/tutorial/beam-enter-referral-code.jpg"],
   isValid: ""
}

export const beutea:ReferralData ={
   title: "BEUTEA Referral Code Malaysia",
   category: "dining,my",
   url: "beutea-referral-code",
   info: "Use BEUTEA referral code <b>LXA0F5F9</b> during Malaysia app signup. Eligible new users receive a <b>50% off voucher and 100 points</b>, subject to the current app terms.",
   logo: "assets/beutea-logo.webp",
   signup: "https://referral.beutea.world/?referral_code=LXA0F5F9",
   index:"beutea",
   dateAdded:1785196800,
   tutorial:["assets/tutorial/beutea-referral-code-lxa0f5f9.webp", "assets/tutorial/beutea-referral-reward-50-off-100-points.webp", "assets/tutorial/beutea-points-vouchers.webp"],
   isValid: ""
}

export const bigpay:ReferralData ={
   title: "BigPay Referral Code",
   index:"bigpay",
   category: "e-wallet,my",
   url: "bigpay-referral-code",
   info: "Use BigPay referral code <b>MZ1XZ29WCI</b> in Malaysia or <b>QIH2GRZQ0M</b> in Singapore. Check the live regional reward and qualifying steps inside BigPay before completing signup.",
   logo: "assets/bigpay-referral-code.png",
   signup: "https://play.google.com/store/apps/details?id=com.tpaay.bigpay",
   dateAdded:1567588740,
   tutorial:["assets/tutorial/bigpay-referral-code-malaysia.PNG","assets/tutorial/bigpay-referral-code-singapore.PNG","assets/tutorial/how-to-enter-bigpay-referral-code.png","assets/tutorial/bigpay-analysis.jpg","assets/tutorial/bigpay-rewards.jpg","assets/tutorial/bigpay-promo-1.PNG","assets/tutorial/bigpay-promo-2.PNG","assets/tutorial/bigpay-promo-3.PNG","assets/tutorial/bigpay-promo-4.PNG","assets/tutorial/bigpay-bill.PNG"],
   isValid: ""
}



export const boost:ReferralData ={
   title: "Boost Invite Code",
   category: "e-wallet,cashback,my",
   url: "boost-invite-code",
   info: "Register with Boost app invite code : <b>kctjytd</b> to get up to rm5 boost coins! Boost App is an e-wallet which you can use to pay without the hassle of using physical cash. Pay with Boost at these participating locations (https://www.myboost.com.my/places/) For prepaid users, top up your mobile prepaid on-the-go with Boost and enjoy cashback after every top up...",
   logo: "assets/boost-invite.png",
   signup: "https://play.google.com/store/apps/details?id=my.com.myboost",
   index:"boost",
   dateAdded:1567588740,
   tutorial:["assets/tutorial/boost-register-step1.PNG","assets/tutorial/boost-register-step2.PNG","assets/tutorial/boost-register-step3.PNG","assets/tutorial/boost-register-step4.PNG"],
   isValid: ""
}

export const boostBank:ReferralData ={
   title: "Boost Bank Referral Code",
   category: "e-wallet,cashback,my",
   url: "boost-bank-referral-code",
   info: "Use Boost Bank referral code <b>tempref</b> in Malaysia. No confirmed new-user referral reward is available yet, so check the live Boost Bank app offer before signup.",
   logo: "assets/boost-favicon.png",
   signup: "https://myboostbank.co/download-boost-bank",
   index:"boostbank",
   dateAdded:1783180800,
   tutorial:[],
   isValid: ""
}

export const breadtalk:ReferralData ={
   title: "BreadTalk Referral Code 2026",
   category: "dining,e-wallet,cashback,sg",
   url: "breadtalk-referral-code",
   info: "Use BreadTalk referral code <b>NksQ</b> when signing up for BreadTalk Group Rewards. Eligible new users can get an <b>S$2 cash eVoucher</b>. This is an app registration code, not a bakery checkout promo code. Check the live voucher terms.",
   logo: "assets/breadtalk-referral.webp",
   signup: "https://play.google.com/store/apps/details?id=com.breadtalk.rewards",
   index:"breadtalk",
   dateAdded:1717909188,
   tutorial:["assets/tutorial/member-tier.jpg","assets/tutorial/rewards.jpg"],
   isValid: ""
}

export const bungkuskawkaw:ReferralData ={
   title: "Bungkus Kaw Kaw Referral Code",
   category: "dining,my",
   url: "bungkuskawkaw-referral-code",
   info: "Use Bungkus Kaw Kaw referral code <b>BYMK37899</b> during Malaysia app signup. The uploaded referral screen shows I get an RM3 voucher for each friend who signs up with the code; no separate guaranteed new-user voucher is confirmed.",
   logo: "assets/bungkuskawkaw-logo.webp",
   signup: "https://play.google.com/store/apps/details?id=my.bungkuskawkaw.app",
   index:"bungkuskawkaw",
   dateAdded:1784332800,
   tutorial:["assets/tutorial/bungkuskawkaw-referral-popup.jpg","assets/tutorial/bungkuskawkaw-signup-referral-code.jpg","assets/tutorial/bungkuskawkaw-rewards-vouchers.jpg"],
   isValid: ""
}


export const cashzine:ReferralData ={
   title: "Cashzine Invitation Code",
   category: "others,my",
   url: "cashzine-invitation-code",
   info: "Use Cashzine invitation code <b>1247883</b>, also known as kode undangan Cashzine. Check the current reward, then earn coins through eligible novel reading, check-ins, games and promotions.",
   logo: "assets/cashzine-invitation.png",
   signup: "https://play.google.com/store/apps/details?id=com.sky.sea.cashzine",
   index:"cashzine",
   tutorial:["assets/tutorial/cashzine-register-step1.PNG","assets/tutorial/cashzine-register-step2.PNG","assets/tutorial/cashzine-register-step3.PNG","assets/tutorial/cashzine-invitation-code.PNG"],
   dateAdded:1567588740,
   isValid: ""
}

export const chagee:ReferralData ={
   title: "CHAGEE Referral Code Malaysia",
   category: "dining,my",
   url: "chagee-referral-code",
   info: "Use CHAGEE referral code <b>sniuRgv</b> during Malaysia app signup. New users who complete an eligible registration with the code receive one <b>50% off voucher</b>.",
   logo: "assets/chagee-logo.png",
   signup: "https://chagee.com.my/",
   index:"chagee",
   tutorial:["assets/tutorial/chagee-referral-code-sniurgv.jpg","assets/tutorial/chagee-referral-rewards.jpg","assets/tutorial/chagee-how-referral-works.jpg"],
   dateAdded:1783180800,
   isValid: ""
}

export const caltexgo:ReferralData ={
   title: "CaltexGO Referral Code",
   category: "my,others",
   url: "caltexgo-referral-code",
   info: "Enter CaltexGO referral code <b>10h79XsNdq</b> during Malaysia signup and complete your first transaction. You and I each receive 500 points, worth about RM5.",
   logo: "assets/caltexgo-logo.png",
   signup: "https://caltexrewardsmy.onelink.me/L2Ge/web",
   index:"caltexgo",
   dateAdded:1781913600,
   tutorial:["assets/tutorial/caltexgo-enter-referral-code.jpg","assets/tutorial/caltexgo-invite-friend.jpg","assets/tutorial/caltexgo-rewards.jpg"],
   isValid: ""
}

export const crypto:ReferralData ={
   title: "Crypto.com Referral Code",
   category: "investment,cryptocurrency",
   url: "crypto.com-referral-code",
   info: "Use Crypto.com referral code <b>t3ab6rfhkh</b>. Rewards depend on your country, KYC approval, and eligible trading volume within the first 30 days. Crypto.com states that the referral programme is currently not available in Singapore.",
   logo: "assets/crypto.jpg",
   signup: "https://crypto.com/app/t3ab6rfhkh",
   index:"crypto",
   tutorial:["assets/tutorial/crypto-register-step1.jpg", "assets/tutorial/crypto-register-step2.jpg", "assets/tutorial/cryptocom-register-step1.jpg", "assets/tutorial/cryptocom-register-step2.jpg",  "assets/tutorial/cryptocom-register-step3.jpg", "assets/tutorial/cryptocom-register-step4.jpg"],
   dateAdded:1731730077,
   isValid: ""
}

export const cultbeauty:ReferralData ={
   title: "Cult Beauty Referral Code",
   category: "others,sg",
   url: "cult-beauty-referral-code",
   info: "Register with Cult Beauty Referral Code : KCAM-R1 to get EUR 5 after your first purchase! Whether you're a skincare enthusiast, makeup lover, or haircare aficionado, Cult Beauty has something for everyone.",
   logo: "assets/cult-beauty-referral-code.webp",
   signup: "https://www.cultbeauty.com/referrals.list?applyCode=KCAM-R1",
   index:"cultbeauty",
   tutorial:["assets/tutorial/cult-beuty-signup.jpg", "assets/tutorial/cult-beauty-referral-code.jpg"],
   dateAdded:1717663999,
   isValid: ""
}

export const dash:ReferralData ={
   title: "Singtel Dash Referral Code",
   category: "e-wallet,sg",
   url: "singtel-dash-referral-code",
   info: "Join Singtel Dash with my referral code <b>DASH-P7IJG</b>. Make a qualifying first overseas remittance and you can earn up to S$9 cashback under the current promotion.",
   logo: "assets/singteldash-referral.png",
   signup: "https://play.google.com/store/apps/details?id=com.SingTel.mWallet",
   index:"dash",
   tutorial:["assets/tutorial/singtel-dash-register-step1.PNG","assets/tutorial/singtel-dash-register-step2.PNG","assets/tutorial/singtel-dash-register-step3.png","assets/tutorial/singtel-dash-referral-code.jpg","assets/tutorial/dash-promotion-1.jpg","assets/tutorial/dash-promotion-2.jpg","assets/tutorial/dash-promotion-3.jpg","assets/tutorial/dash-promotion-4.jpg","assets/tutorial/dash-promotion-5.jpg","assets/tutorial/dash-promotion-6.jpg","assets/tutorial/dash-promotion-7.jpg","assets/tutorial/dash-promotion-8.jpg","assets/tutorial/dash-promotion-9.jpg","assets/tutorial/dash-promotion-10.jpg"],
   dateAdded:1567588740,
   isValid: ""
}


export const enrichMoney:ReferralData ={
   title: "EnrichMoney Referral Code",
   category: "e-wallet,my",
   url: "enrich-money-referral-code",
   info: "Use EnrichMoney referral code <b>3E1A0A6ADC</b> during signup to get RM10 within 21 days, subject to current app terms. The registration screenshot confirms the referral field.",
   logo: "assets/enrich-money-logo.png",
   signup: "https://enrich.malaysiaairlines.com/",
   index:"enrichmoney",
   tutorial:["assets/tutorial/enrich-money-referral-code.jpg","assets/tutorial/enrich-money-signup-referral-field.jpg","assets/tutorial/enrich-money-cash-in-received.jpg"],
   dateAdded:1782432000,
   isValid: ""
}

export const easybook:ReferralData ={
   title: "Easybook Referral Code",
   category: "my,others",
   url: "easybook-referral",
   info: "Use my Easybook referral link with code <b>A5BF97C3</b> in Malaysia. New users can receive RM32 Reward Cash after successful registration, subject to Easybook's current referral terms.",
   logo: "assets/easybook-logo.png",
   signup: "https://www.easybook.com/en-my/account/register?raf=A5BF97C3",
   index:"easybook",
   dateAdded:1784289600,
   tutorial:["assets/tutorial/easybook-referral-reward.jpg", "assets/tutorial/easybook-referral-steps.jpg"],
   isValid: ""
}



export const fave:ReferralData ={
   title: "Fave Promo Code",
   category: "e-wallet,cashback,my,sg,dining",
   url: "fave-promo-code",
   info: "Use Fave promo code : <b>BDNGI</b> when signing up or adding a Fave referral code. Fave helps users find dining deals, cashback, FavePay rewards, eCards, and discounts across participating merchants in Singapore and Malaysia...",
   logo: "assets/fave-referral.jpg",
   signup: "https://play.google.com/store/apps/details?id=com.kfit.fave",
   index:"fave",
   tutorial:["assets/tutorial/fave-register-step1.PNG","assets/tutorial/fave-register-step2.PNG","assets/tutorial/fave-register-step3.PNG","assets/tutorial/fave-promo-code.PNG"],
   dateAdded:1567588740,
   isValid: ""
}

export const fastgig:ReferralData ={
   title: "FastGig Referral Code",
   category: "my,sg,others",
   url: "fastgig-referral-code",
   info: "Use FastGig referral code <b>GFG6W76714</b> when signing up. No confirmed new-user reward amount is shown, so enter the code during registration and check the latest FastGig app terms.",
   logo: "assets/fastgig-logo.png",
   signup: "https://play.google.com/store/apps/details?id=com.fastco.fastgig2",
   index:"fastgig",
   dateAdded:1783123200,
   tutorial:["assets/tutorial/fastgig-referral-code.jpg","assets/tutorial/fastgig-enter-referral-code.jpg","assets/tutorial/fastgig-job-listings.jpg"],
   isValid: ""
}



export const foneApp:ReferralData ={
   title: "FoneApp Referral Code",
   category: "others,my,shopping",
   url: "foneapp-referral-code",
   info: "Sign up by using the FoneApp referral code <b>kccwlim2</b> and get extra points in FoneApp when you register!",
   logo: "assets/foneapp-referral.png",
   signup: "https://play.google.com/store/apps/details?id=io.mxapps.forestone",
   index:"foneapp",
   tutorial:["assets/tutorial/foodpanda-register-step1.PNG","assets/tutorial/foodpanda-register-step2.PNG","assets/tutorial/foodpanda-register-step3.PNG"],
   dateAdded:1567588740,
   isValid: ""
}

export const foodpanda:ReferralData ={
   title: "FoodPanda Referral Code",
   category: "my,sg,dining",
   url: "foodpanda-voucher-october-2022",
   info: "Check out the latest Foodpanda Promo Code October 2022 for both Singapore and Malaysia! Sign up by using the <a href=\"https://fdpnda.app.link/UXkJcgohM2\" target=\"_blank\">foodpanda referral link</a> to get RM10/SGD10 off for your first order!...",
   logo: "assets/foodpanda-referral.png",
   signup: "https://fdpnda.app.link/UXkJcgohM2",
   index:"foodpanda",
   tutorial:["assets/tutorial/foodpanda-register-step1.PNG","assets/tutorial/foodpanda-register-step2.PNG","assets/tutorial/foodpanda-register-step3.PNG"],
   dateAdded:1567588740,
   isValid: ""
}

export const funcrush:ReferralData ={
   title: "FunCrush Invitation Code",
   category: "my,others",
   url: "funcrush-invitation-code",
   info: "Enter FunCrush invitation code <b>27735844</b> from the invitation-code screen. FunCrush is a match-3 fruit puzzle game with levels, coin rewards, competitions, and social invitations.",
   logo: "assets/funcrush-invitation.webp",
   signup: "https://play.google.com/store/apps/details?id=com.pointsculture.funcrush",
	index:"funcrush",
   dateAdded:1714137498,
	tutorial:["assets/tutorial/funcrush-register-step1.jpg","assets/tutorial/funcrush-register-step2.jpg","assets/tutorial/funcrush-invitation-code.jpg"],
   isValid: ""
}

export const fundrama:ReferralData ={
   title: "FunDrama Invitation Code",
   category: "my,others",
   url: "fundrama-invitation-code",
   info: "Use FunDrama invitation code <b>52869978</b> from Me &gt; Enter Invitation Code to claim the currently shown 30,000-point bonus. The code can only be entered once and cannot be changed afterward.",
   logo: "assets/fundrama-invitation.webp",
   signup: "https://play.google.com/store/apps/details?id=com.pointsculture.fundrama&hl=en",
	index:"fundrama",
   dateAdded:1741516799,
	tutorial:["assets/tutorial/fundrama-register-step1.jpg","assets/tutorial/fundrama-register-step2.jpg","assets/tutorial/fundrama-invitation-code.jpg"],
   isValid: ""
}

export const funflip:ReferralData ={
   title: "FunFlip Invitation Code",
   category: "others,my",
   url: "funflip-invitation-code",
   info: "Register FunFlip with FunFlip invitation code : <b>52916105</b> to get RM4! Funflip is a free topic & post content app that finds high-quality content that meets your interests - topics, posts, etc....",
   logo: "assets/funflip.webp",
   signup: "https://play.google.com/store/apps/details?id=com.pointsculture.funflip&hl=en&gl=US",
	index:"funflip",
	tutorial:["assets/tutorial/funflip-register-step1.jpg","assets/tutorial/funflip-register-step2.jpg","assets/tutorial/funflip-invitation-code.jpg","assets/tutorial/foodpanda-register-step3.PNG"],
   dateAdded:1644741646,
   isValid: ""
}

export const getbats:ReferralData ={
   title: "Getbats Referral Code",
   category: "cashback,my",
   url: "getbats-referral-code",
   info: "Sign up GETBATS and get bonus cashback after your first minimum purchase of RM20. GETBATS is a rebate platform for its members to gain instant cash rebates when shopping online and offline.",
   logo: "assets/getbats.webp",
   signup: "https://m.getbats.com/en/register-customer.phtml?ReferralID=312976804",
	index:"getbats",
	tutorial:["assets/tutorial/getbats-step-1.jpg","assets/tutorial/getbats-step-2.jpg","assets/tutorial/getbats-step-3.jpg","assets/tutorial/getbats-step-4.jpg"],
	dateAdded:1668223341,
   isValid: ""
}

export const guardian:ReferralData ={
   title: "Guardian Referral Code",
   category: "others,my",
   url: "guardian-referral-code",
   info: "Use Guardian referral code <b>96032965</b> when signing up for Guardian MY to get 150 Guardian Points. Redeem RM1 discount with 200 points where eligible.",
   logo: "assets/guardian.webp",
   signup: "https://play.google.com/store/apps/details?id=com.Gguardian&hl=en",
	index:"guardian",
	tutorial:[],
	dateAdded:1743165754,
   isValid: ""
}

export const googlePay:ReferralData ={
   title: "GooglePay Referral Code",
   category: "e-wallet,cashback,sg",
   url: "googlepay-referral-code",
   info: "Use Google Pay referral code <b>vm0086d</b> in Singapore and check the live first-payment referral reward in the app. Reward amounts and qualifying-payment terms can change.",
   logo: "assets/googlepay-referral.png",
   signup: "https://play.google.com/store/apps/details?id=com.google.android.apps.nbu.paisa.user",
	index:"googlepay",
	tutorial:["assets/tutorial/google-pay-register-step1.png","assets/tutorial/google-pay-register-step2.jpg","assets/tutorial/google-pay-referral-code.PNG"],
	dateAdded:1608188731,
   isValid: ""
}


export const gxbank:ReferralData ={
   title: "GXBank Referral & Promo Code",
   category: "e-wallet,cashback,my,investment",
   url: "gxbank-referral-code",
   info: "Use GXBank referral code <b>LIMK885</b>. You and I can each earn RM100 from FlexiCredit and RM125 from Biz FlexiLoan by 30 September 2026, subject to approval and current terms.",
   logo: "assets/gxbank.webp",
   signup: "https://gxbank-business.onelink.me/BdAg/kre5ftdt",
	index:"gxbank",
	tutorial:["assets/tutorial/gxbank-register-1.jpg", "assets/tutorial/gxbank-referral-code.jpg", "assets/tutorial/gxbank-register-2.jpg", "assets/tutorial/gxbank-register-3.jpg"],
	dateAdded:1718283952,
   isValid: ""
}

export const hata:ReferralData ={
   title: "Hata Buddy Bonus and Affiliate Code",
   category: "investment,crypto,my",
   url: "hata-buddy-bonus-code",
   info: "Use Hata Buddy Bonus code <b>BB02TRHHAA</b> to unlock up to RM40 together, or Hata affiliate code <b>AF01YV4GAA</b> for a 10% trading-fee rebate.",
   logo: "assets/hata.webp",
   signup: "https://app.hata.io/register",
	index:"hata",
	dateAdded: 1734254125,
	tutorial:["assets/tutorial/hata-buddy-bonus-code-bb02trhhaa.jpg","assets/tutorial/hata-affiliate-code-af01yv4gaa.jpg","assets/tutorial/hata-buddy-bonus-rewards-hub-bb02trhhaa.jpg","assets/tutorial/securities-commission.jpg"],
   isValid: ""
}


export const hoshinoCoffee:ReferralData ={
   title: "Hoshino Coffee Referral Code",
   category: "dining,sg",
   url: "hoshino-coffee-referral-code-2022",
   info: "Use Hoshino Coffee referral code C42AS5 when joining the Doutor NRS rewards club in Singapore. The signup evidence shows 10 reward points for new members who enter the code, plus access to rewards across Hoshino Coffee, Chopsticks by The Asian Kitchen and Cafe Aux Bacchanales.",
   logo: "assets/hoshino-coffee.webp",
   signup: "https://dn-s.eber.co/sign-in",
	index:"hoshino",
	dateAdded: 1665055153,
	tutorial:["assets/tutorial/hoshino-coffee-reward.png","assets/tutorial/cafe-aux-reward.png","assets/tutorial/chopsticks-reward.png","assets/tutorial/hoshino-coffee-birthday-reward.png","assets/tutorial/hoshino-coffee-sign-up-1.png","assets/tutorial/hoshino-coffee-sign-up-2.png","assets/tutorial/hoshino-coffee-install.jpg"],
   isValid: ""
}

export const hotTomato:ReferralData ={
   title: "Hot Tomato Referral Code",
   category: "dining,sg",
   url: "hot-tomato-referral-code",
   info: "Join Hot Tomato Rewards with referral code <b>kOTy</b> to check the current HT$1 referral benefit, free lifetime membership, welcome soup and ice lemon tea voucher, cash rebates, and birthday perks.",
   logo: "assets/hot-tomato.png",
   signup: "https://member.hottomato.com.sg/Signup?ReferralCode=kOTy",
	index:"hottomato",
	dateAdded: 1675823725,
	tutorial:["assets/tutorial/hot-tomato-welcome-gift.PNG","assets/tutorial/hot-tomato-referral-code.PNG"],
   isValid: ""
}

export const innisfree:ReferralData ={
   title: "Innisfree Referral Link",
   category: "my,shopping,others",
   url: "innisfree-referral-code",
   info: "Open my Innisfree Malaysia <a href=\"https://refrr.app/ObGQ0VDhbq/153151\" target=\"_blank\" rel=\"sponsored noopener\">referral link</a> before signup. The referral screen says new users get <b>15% off</b>. Check the live cart because Innisfree does not confirm that this stacks with its separate first-purchase membership offer.",
   logo: "assets/innisfree-logo.svg",
   signup: "https://refrr.app/ObGQ0VDhbq/153151",
   index:"innisfree",
   dateAdded:1785340800,
   tutorial:["assets/tutorial/innisfree-referral-link-15-percent-off.jpg","assets/innisfree-membership-15-off-welcome-gift.jpg","assets/tutorial/innisfree-in-store-membership-benefits.jpg"],
   isValid: ""
}


export const jag:ReferralData ={
   title: "Jag Referral Code",
   category: "my,sg,others",
   url: "jag-referral-code",
   info: "Enter JAG referral username <b>Kccwlim</b> during registration. The saved JAG screenshot confirms the referral field, but no confirmed new-user points bonus is shown. Check the app for current missions and rewards.",
   logo: "assets/jag-referral.jpg",
   signup: "https://play.google.com/store/apps/details?id=com.jagideas",
	index:"jag",
	dateAdded:1567588740,
	tutorial:["assets/tutorial/jag-register-step1.PNG","assets/tutorial/jag-register-step2.PNG","assets/tutorial/jag-referral-code.PNG"],
   isValid: ""
}

export const kdi:ReferralData ={
   title: "Kdi Referral Code",
   category: "my,sg,investment",
   url: "kdi-referral-code",
   info: "Use KDI referral code <b>108804</b> during registration. Check the current referral campaign before investing, then compare KDI Save and KDI Invest based on your goals and risk tolerance.",
   logo: "assets/kdi-referral.webp",
   signup: "https://app.digitalinvesting.com.my/registration/signup?referral_code=108804",
	index:"kdi",
	dateAdded:1653104042,
	tutorial:["assets/tutorial/kdi-referral-code.jpg","assets/tutorial/kdi-register-step2.PNG","assets/tutorial/kdi-referral-code.PNG"],
   isValid: ""
}

export const kmiles:ReferralData ={
   title: "KMiles Referral Code",
   category: "my,shopping,cashback,others",
   url: "kmiles-referral-code",
   info: "Use KMiles referral code <b>4RMZ2P</b> during signup. You and I both receive <b>250 KMiles</b> after your first KMiles transaction is completed.",
   logo: "assets/kmiles-logo.webp",
   signup: "https://play.google.com/store/apps/details?id=com.mykmiles.app",
   index:"kmiles",
   dateAdded:1783123200,
   tutorial:["assets/tutorial/kmiles-signup-referral-code.jpg","assets/tutorial/kmiles-referral-code-4rmz2p.jpg","assets/tutorial/kmiles-earn-merchants.jpg","assets/tutorial/kmiles-redeem-vouchers.jpg"],
   isValid: ""
}

export const krisplus:ReferralData ={
   title: "Kris+ Referral Code",
   category: "sg,others",
   url: "kris-referral-code",
   info: "Use Kris+ referral code <b>L142913</b> during your first login and complete an eligible transaction. The official page lists 750 KrisPay miles, while the account screenshot shows 500 miles, so confirm the live in-app offer.",
   logo: "assets/krisplus.webp",
   signup: "https://app.krisplus.com/XdUvHxlcI3b",
	index:"krisplus",
	dateAdded:1663675944,
	tutorial:["assets/tutorial/kris-sign-up-520.jpg","assets/tutorial/kris-referral-code-520.jpg","assets/tutorial/kris-deals-520.jpg"],
   isValid: ""
}



export const lendlease:ReferralData ={
   title: "Lendlease Plus Referral Code",
   category: "sg,others",
   url: "lendlease-plus-referral-code",
   info: "Use Lendlease Plus referral code <b>wXy8Mn</b> during registration. Check the live signup offer, then earn Plus$ for eligible spending at participating Lendlease malls.",
   logo: "assets/lendlease-pluse-referral-code.webp",
   signup: "https://play.google.com/store/apps/details?id=com.lendlease.plus",
   index:"lendlease",
   dateAdded:1634367489,
   isValid: "",
   tutorial:["assets/tutorial/lendlease-plus-register-step1.jpg","assets/tutorial/lendlease-plus-register-step2.jpg","assets/tutorial/lendlease-plus-register-step3.jpg"]
}

export const lookfantastic:ReferralData ={
   title: "Lookfantastic Referral Code",
   category: "sg,others",
   url: "lookfantastic-referral-code",
   info: "Use LOOKFANTASTIC referral code <b>YIK-R3P</b> for a first eligible order. Check the current regional reward, minimum spend, exclusions and delivery availability.",
   logo: "assets/lookfantastic.png",
   signup: "https://www.lookfantastic.com.sg/referrals.list?applyCode=YIK-R3P",
   index:"lookfantastic",
   dateAdded:1691588591,
   isValid: "",
   tutorial:["assets/tutorial/lookfantastic-products.PNG","assets/tutorial/lookfantastic-sales.PNG","assets/tutorial/lookfantastic-register-step1.PNG","assets/tutorial/lookfantastic-referral-code.PNG", "assets/tutorial/lookfantastic-skincare.jpg", "assets/tutorial/lookfantastic-main.jpg"]
}

export const luno:ReferralData ={
   title: "Luno Promo Code",
   category: "my,investment,cryptocurrency",
   url: "luno-promo-code",
   info: "Enter Luno promo code <b>RMK5TM</b> in the Rewards section after account verification. Check the live reward and qualifying trade before buying crypto.",
   logo: "assets/luno-invite.png",
   signup: "https://play.google.com/store/apps/details?id=co.bitx.android.wallet&hl=en&gl=US",
   index:"luno",
   dateAdded:1624689070,
   tutorial:["assets/tutorial/luno-register-step1.PNG","assets/tutorial/luno-register-step2.PNG","assets/tutorial/luno-register-step3.PNG","assets/tutorial/luno-register-step4.PNG","assets/tutorial/luno-register-step5.PNG","assets/tutorial/luno-register-step6.jpg","assets/tutorial/luno-promo-code.jpg"],
   isValid: ""
}

export const luckin:ReferralData ={
   title: "Luckin Coffee Referral",
   category: "dining,my,sg",
   url: "luckin-referral-code",
   info: "Start with the Luckin Coffee referral link for Malaysia or Singapore new users and check the current app promotion before your first order.",
   logo: "assets/luckin.webp",
   signup: "http://iyyds.co/wteGCQBe",
   index:"luckin",
   dateAdded:1780598400,
   isValid: "",
   tutorial:["assets/tutorial/luckin-referral-program.jpg","assets/tutorial/luckin-how-referral-works.jpg","assets/tutorial/luckin-referral-code-2026.jpg"]
}

export const milkadeal:ReferralData ={
   title: "Milkadeal Referral Code",
   category: "my,sg,shopping,cashback",
   url: "milkadeal-referral-code",
   info: "Register milkadeal with referral code <b>YNWDLG</b> to get rm5 after you made your first purchase!",
   logo: "assets/milkadeal-referral.jpg",
   signup: "https://play.google.com/store/apps/details?id=com.milkadeal.cashback",
   index:"milkadeal",
   dateAdded:1590300841,
	tutorial:["assets/tutorial/milkadeal-register-step1.PNG","assets/tutorial/milkadeal-referral-code.PNG"],
   isValid: ""
}


export const moomoo:ReferralData ={
   title: "MooMoo Referral Link",
   category: "my,investment",
   url: "moomoo-referral-code",
   info: "Open my MooMoo Malaysia referral link. The current promotion screens show rewards tied to registration, deposits and transfers. Check the live terms before funding your account.",
   logo: "assets/moomoo-logo.png",
   signup: "https://j.moomoo.com/0CvIyT",
	index:"moomoo",
   dateAdded:1619930591,
   tutorial: ["assets/tutorial/moomoo-referral-rewards-2026.jpg", "assets/tutorial/moomoo-new-user-rewards-2026.jpg"],
   isValid: ""
}

export const myprotein:ReferralData ={
   title: "Myprotein Referral Code",
   category: "my,others",
   url: "myprotein-referral-code",
   info: "Use Myprotein referral code <b>SOH-R7B</b> or the referral link as a new Singapore customer. Check the current first-order discount and eligible products at checkout.",
   logo: "assets/myprotein-referral.jpg",
   signup: "https://www.myprotein.com.sg/referrals.list?applyCode=SOH-R7B",
	index:"myprotein",
   dateAdded:1595748718,
	tutorial:["assets/tutorial/myprotein-register-step1.PNG","assets/tutorial/myprotein-referral-code.PNG","assets/tutorial/myprotein-products.PNG","assets/tutorial/myprotein-sales.png"],
   isValid: ""
}


export const novelah:ReferralData ={
   title: "Novelah Invitation Code",
   category: "my,others",
   url: "novelah-invitation-code",
   info: "Use Novelah invitation code <b>908260</b> from Me &gt; Enter Invitation Code. Check the current point bonus before submitting, then read free local fiction and earn points through eligible activities.",
   logo: "assets/novelah-invitation.webp",
   signup: "https://play.google.com/store/apps/details?id=com.novel.novelah",
	index:"novelah",
   dateAdded:1629560144,
	tutorial:["assets/tutorial/novelah-register-step1.jpg","assets/tutorial/novelah-register-step2.jpg","assets/tutorial/novelah-invitation-code.jpg"],
   isValid: ""
}


export const octafx:ReferralData ={
   title: "OctaFx Invitation Link",
   category: "my,investment",
   url: "octafx-invitation",
   info: "Register Octafx with invitation link : <b>https://www.octafx.com/?refid=if14903304</b> and start trading today! OctaFx is a trading broker which allow you to manage your personal profiles,control real, demo and contest accounts.",
   logo: "assets/octafx-invitation.webp",
   signup: "https://www.octafx.com/?refid=if14903304",
   index:"octafx",
   dateAdded:1634966690,
   tutorial:["assets/tutorial/novelah-register-step1.jpg","assets/tutorial/novelah-register-step2.jpg","assets/tutorial/novelah-invitation-code.jpg"],
   isValid: ""
}

export const parisBaguette:ReferralData ={
   title: "Paris Baguette Referral Code",
   category: "dining,my,sg",
   url: "paris-baguette-referral-code",
   info: "Join PB Rewards with Paris Baguette referral code <b>ROACI2</b> in Malaysia or <b>P9PTLF</b> in Singapore. Malaysia and Singapore use separate referral links and reward rules.",
   logo: "assets/paris-baguette-logo.png",
   signup: "https://rewards.parisbaguette.com.my/r/ROACI2",
   index:"parisbaguette",
   dateAdded:1781827200,
   tutorial:["assets/tutorial/paris-baguette-malaysia-referral-program.jpg","assets/tutorial/paris-baguette-malaysia-rewards.jpg","assets/tutorial/paris-baguette-referral-points-proof.jpg"],
   isValid: ""
}

export const paragonClub:ReferralData ={
   title: "Paragon Club Referral Code",
   category: "shopping,sg,others",
   url: "paragon-club-referral-code",
   info: "Use Paragon Club referral code <b>LThRK</b> and receive 25 points worth S$10 after signing up and spending S$50 or more in one receipt.",
   logo: "assets/paragon-club-logo.jpg",
   signup: "https://paragon.com.sg/paragon-club/",
   index:"paragonclub",
   dateAdded:1781827200,
   tutorial:["assets/tutorial/paragon-club-registration-referral-code.jpg","assets/tutorial/paragon-club-refer-a-friend.jpg","assets/tutorial/paragon-club-rewards-deals.jpg","assets/tutorial/paragon-club-welcome-vouchers.jpg"],
   isValid: ""
}


export const petron:ReferralData ={
   title: "Petron Referral Code",
   category: "my,others",
   url: "petron-referral-code",
   info: "Join Petron Mobile App with my referral code <b>ABC-706000</b>. You can receive 100 Petron Miles points after successful registration and one successful purchase at a Petron station in Malaysia within 30 days.",
   logo: "assets/petron-logo.webp",
   signup: "https://play.google.com/store/apps/details?id=my.com.petron.app",
   index:"petron",
   dateAdded:1782432000,
   tutorial:["assets/tutorial/petron-referral-code.jpg","assets/tutorial/petron-rewards-rm10-vouchers.jpg","assets/tutorial/petron-rewards-rm20-rm50-vouchers.jpg"],
   isValid: ""
}




export const rewardLand:ReferralData ={
   title: "Reward Land Referral Code",
   category: "e-wallet,others,sg",
   url: "reward-land-referral-code",
   info: "Use Reward Land referral code <b>V49P2lcw</b> in Singapore to get the current 1,000 R Coins welcome reward, then earn more R Coins from cashback, vouchers, promotions, and referrals. Updated 2026.",
   logo: "assets/rewardland.webp",
   signup: "https://share.rewardland.sg/EwIe?pid=shareLink&c=shareLink&af_dp=dl&af_force_deeplink=true&referral_id=V49P2lcw&deep_link_value=referral_id&deep_link_sub1=V49P2lcw",
   index:"rewardland",
   dateAdded:1777194292,
	tutorial:["assets/tutorial/reward-land-referral-code.jpg", "assets/tutorial/reward-land-merchant.jpg"],
   isValid: ""
}

export const rollti:ReferralData ={
   title: "Rollti Referral Code",
   category: "dining,my",
   url: "rollti-referral-code",
   info: "Use Rollti referral code <b>KCCW7682</b> in Malaysia when registering. New users who use the code get an RM10 voucher for Rollti orders, subject to current app terms.",
   logo: "assets/rollti-logo.png",
   signup: "https://play.google.com/store/apps/details?id=com.rollti.app.pro",
   index:"rollti",
   dateAdded:1784256000,
   tutorial:["assets/tutorial/rollti-referral-code-kccw7682.jpg", "assets/tutorial/rollti-rm10-voucher.jpg"],
   isValid: ""
}

export const ryde:ReferralData ={
   title: "Ryde Referral",
   category: "e-wallet,others,sg",
   url: "ryde-referral",
   info: "Use my Ryde referral link in Singapore: <a href=\"https://ryde.app.link/CA0wqy4px4b\" target=\"_blank\">https://ryde.app.link/CA0wqy4px4b</a>. The Ryde invite screen says you get <b>S$5</b> and I get <b>S$5</b>, credited via RydeCoins after the new account signup process is completed.",
   logo: "assets/ryde-logo.png",
   signup: "https://ryde.app.link/CA0wqy4px4b",
   index:"ryde",
   dateAdded:1783795200,
   tutorial:["assets/tutorial/ryde-referral-code.jpg", "assets/tutorial/ryde-plus-savings.jpg", "assets/tutorial/ryde-plus-cashback.jpg"],
   isValid: ""
}


export const secretrecipe:ReferralData ={
   title: "Secret Recipe Referral Code",
   category: "e-wallet,my,dining",
   url: "secret-recipe-referral-code",
   info: "Join Secret Recipe with referral code <b>4FUWFM</b>. New SR Rewards members currently receive Free Coffee, 10% Off and RM3 Cash welcome vouchers.",
   logo: "assets/secret-recipe.webp",
   signup: "https://member.secretrecipe.com.my/r/4FUWFM",
   index:"secretrecipe",
	dateAdded:1664291409,
	tutorial:["assets/tutorial/secret-recipe-rewards.jpg","assets/tutorial/secret-recipe-member-rewards.jpg","assets/tutorial/secret-recipe-spin-win.PNG","assets/tutorial/secret-recipe-welcome-gift.jpg","assets/tutorial/secret-recipe-sign-up.jpg"],
   isValid: ""
}

export const setel:ReferralData ={
   title: "Setel Referral Code",
   category: "e-wallet,my",
   url: "setel-referral-code",
   info: "Register a Setel account with Setel referral code : <b>zhhgk</b> to get RM3 Setel Credit after your first cumulative RM30 spend on fuel and/or Kedai Mesra in the Setel app. Campaign terms apply.",
   logo: "assets/setel-referral.jpg",
   signup: "https://play.google.com/store/apps/details?id=com.setel.mobile",
   index:"setel",
	dateAdded:1586596740,
	tutorial:["assets/tutorial/setel-register-step1.jpg","assets/tutorial/setel-referral-code.jpg","assets/tutorial/setel-register-step2.jpg"],
   isValid: ""
}

export const shell:ReferralData ={
   title: "Shell Referral Code",
   category: "e-wallet,sg",
   url: "shell-referral-code",
   info: "Register a Shell Asia account with Shell referral code <b>7fqjy3ecu</b>. Learn how the Shell Asia referral code and Shell GO+ rewards work for app users who want Shell points, fuel rewards, vouchers and easier station payments.",
   logo: "assets/shell.webp",
   signup: "https://play.google.com/store/search?q=shell%20asia&c=apps",
   index:"shell",
	dateAdded:1691158654,
	tutorial:["assets/tutorial/setel-register-step1.jpg","assets/tutorial/setel-referral-code.jpg","assets/tutorial/setel-register-step2.jpg"],
   isValid: ""
}

export const shopback:ReferralData ={
   title: "Shopback Referral Code",
   category: "shopping,cashback,my,sg",
   url: "shopback-referral-code",
   info: "Use ShopBack referral code <b>OB45DK</b> when signing up. Learn the latest Singapore referral requirements, qualifying spend, confirmed cashback rules, and cashback tips.",
   logo: "assets/shopback-referral.jpg",
   signup: "https://app.shopback.com/mys?raf=xDh8hA&slug=referred-signup-bonus",
   index:"shopback",
   dateAdded:1567588740,
   tutorial:[],
   isValid: ""
}


export const shopee:ReferralData ={
   title: "Shopee Promo Code",
   category: "shopping,my,sg",
   url: "shopee-promo-code",
   info: "Register Shopee account and use Shopee promo code : <b>FONG8225</b> (Malaysia) or <b>KCCWL222</b> (Singapore) when you checkout to get RM8 off for Malaysia users or SGD10 off for Singapore users!! Apply promo code into the “Voucher” box when you check out (only valid for the first time user)....",
   logo: "assets/shopee-promo.jpg",
   signup: "https://shopee.com.my/",
	index:"shopee",
   dateAdded:1587870156,
   tutorial:[],
   isValid: ""
}

export const shopfareast:ReferralData ={
   title: "Shopfareast Referral Code",
   category: "shopping,sg",
   url: "shopfareast-referral-code",
   info: "Use shopFarEast referral code <b>aiWCKX</b> during registration. Check the live referral reward, then earn SFE$ by uploading eligible receipts from participating Far East Malls.",
   logo: "assets/shopfareast.webp",
   signup: "https://shopfareastapp.page.link/5HqmxB7sjt4CXSUy8",
	index:"shopfareast",
   dateAdded:1753166305,
   tutorial:[],
   isValid: ""
}

export const socash:ReferralData ={
   title: "SOCASH Referral Code",
   category: "others,sg",
   url: "socash-referral-code",
   info: "Register SOCASH with SOCASH referral code : <b>LION2156</b>  when you register and get SGD3 cashback credit to your account after your first SOCASH withdrawal!....",
   logo: "assets/socash-referral.png",
   signup: "https://play.google.com/store/apps/details?id=io.socash.withdrawal.user",
	index:"socash",
   dateAdded:1608874978,
	tutorial:["assets/tutorial/socash-register-step1.PNG","assets/tutorial/socash-referral-code.PNG"],
   isValid: ""
}

export const storymorph:ReferralData ={
   title: "Storymorph Invitation Code",
   category: "others,my,sg",
   url: "storymorph-invitation-code",
   info: "Use StoryMorph invitation code <b>64172396</b> in Me &gt; Enter Invitation Code to claim the currently shown 30,000-point bonus. The code can only be entered once and cannot be changed afterward.",
   logo: "assets/storymorph.webp",
   signup: "https://play.google.com/store/apps/details?id=com.pointsculture.storymorph",
	index:"storymorph",
   dateAdded:1777803845,
	tutorial:["assets/tutorial/storymorph-step-1.jpg","assets/tutorial/storymorph-step-2.jpg","assets/tutorial/storymorph-step-3.jpg"],
   isValid: ""
}

export const suntecplus:ReferralData ={
   title: "Suntec+ Referral Code",
   category: "shopping,sg",
   url: "suntec-referral-code",
   info: "Register Suntec+ with referral code <b>WI8INDD10</b> to get 2,000 points after completing an eligible $20 approved receipt upload or Suntec+ Eats spend. Start earning rewards when you shop and dine at Suntec City Singapore.",
   logo: "assets/suntecplus.webp",
   signup: "https://suntecplus.com/referral?referralCode=WI8INDD10",
	index:"suntecplus",
   dateAdded:1676551503,
	tutorial:["assets/tutorial/suntec-reward.jpg","assets/tutorial/suntecplus-referral-code.jpg"],
   isValid: ""
}


export const tigerTrade:ReferralData ={
   title: "TigerTrade Referral Code",
   category: "investment,sg",
   url: "tiger-trade-referral-code",
   info: "Use Tiger Brokers referral code <b>PVCVY2</b> when opening a Singapore Tiger Trade account. Check the official Rewards Centre for the current referral and welcome-promotion requirements.",
   logo: "assets/tiger-trade.webp",
   signup: "https://play.google.com/store/apps/details?id=com.tigerbrokers.stock&pageId=none",
	index:"tigertrade",
   dateAdded:1645938005,
	tutorial:["assets/tutorial/tiger-trade-referral-code.jpg"],
   isValid: ""
}

export const time:ReferralData ={
   title: "Time Referral Promo",
   category: "my,others",
   url: "time-referral-promotion",
   info: "Register with TIME <a href='huae.time.com.my/?313245210823'>referral link</a>  and get RM100 voucher with FREE MESH WiFI!",
   logo: "assets/time.webp",
   signup: "huae.time.com.my/?313245210823",
   index:"time",
   dateAdded:1693142739,
   isValid: "",
   tutorial:[]
}

export const rytBank:ReferralData ={
   title: "Ryt Bank Referral Code",
   category: "my,e-wallet,others",
   url: "ryt-bank-referral-code",
   info: "Use Ryt Bank referral code <b>5KLZV</b> during Malaysia account opening. Activate your account and complete an eligible RM10 transaction through Ryt AI. You and I can each receive a random cash reward of up to RM50.",
   logo: "assets/ryt-bank-logo.png",
   signup: "https://rytbank.onelink.me/xS1y?pid=organic_web&c=organic_web&af_channel=download&is_retargeting=true&af_dp=my.rytbank.app",
   index:"rytbank",
   dateAdded:1782000000,
   tutorial:["assets/tutorial/ryt-bank-referral-code.jpg","assets/tutorial/ryt-bank-referral-steps.jpg","assets/tutorial/ryt-bank-rewards.jpg"],
   isValid: ""
}

export const tripcom:ReferralData ={
   title: "Trip.com Referral Code Malaysia",
   category: "my,others",
   url: "trip-com-referral-code",
   info: "Use Trip.com referral code <b>GTTCBP</b>. New users can get RM20 worth of hotel and flight promo codes while referrers earn RM20 Trip Coins per successful invite.",
   logo: "assets/trip-com-logo.svg",
   signup: "https://my.trip.com/sale/4283/referee.html?locale=en-MY&referCode=GTTCBP",
   index:"tripcom",
   dateAdded:1781438400,
   tutorial:["assets/tutorial/trip-com-how-to-use-referral-code.jpg","assets/tutorial/trip-com-referral-reward.jpg"],
   isValid: ""
}

export const trustBank:ReferralData ={
   title: "Trust Bank Referral Code",
   category: "cashback,investment,sg",
   url: "trust-bank-referral-code",
   info: "Use Trust Bank referral code <b>WNBZK5U6</b> during signup to receive a sure-win scratch card after a successful eligible application. Open it in the Trust app to reveal your reward. I receive S$8 for a Savings Account referral or S$18 for an eligible credit-card referral.",
   logo: "assets/trustbank.webp",
   signup: "https://trustbank.sg/",
	index:"trustbank",
   dateAdded:1662043658,
	tutorial:["assets/tutorial/trust-bank-referral-code-2026.webp","assets/tutorial/trust-bank-referral-s8-awarded-2026.webp","assets/tutorial/about-trust-bank.webp"],
   isValid: ""
}


export const versa:ReferralData ={
   title: "Versa Referral Code Malaysia",
   category: "investment,my",
   url: "versa-referral-code",
   info: "Use Versa referral code Malaysia: <b>LN7VHQEX</b> to get RM10 after account approval and a minimum RM100 cash-in. Learn how Versa Cash, Cash-i, referral rewards, and withdrawal rules work. ...",
   logo: "assets/versa.webp",
   signup: "https://download.versa.com.my/1bAf/referral?deep_link_value=LN7VHQEX",
   index:"versa",
   dateAdded:1676089299,
	tutorial:["assets/tutorial/versa-referral-code.jpg","assets/tutorial/wahed-register-step2.PNG","assets/tutorial/wahed-register-step3.PNG"],
   isValid: ""
}

export const wahed:ReferralData ={
   title: "Wahed Referral Code",
   category: "investment,my,sg",
   url: "wahed-referral-code",
   info: "Use Wahed referral code <b>kahlim1</b> as a first-time Malaysia user and invest at least RM200 to receive the current RM20 referral reward.",
   logo: "assets/wahed-referral.png",
   signup: "https://play.google.com/store/apps/details?id=com.wahed.mobile",
   index:"wahed",
   dateAdded:1589453871,
	tutorial:["assets/tutorial/wahed-register-step1.PNG","assets/tutorial/wahed-register-step2.PNG","assets/tutorial/wahed-register-step3.PNG"],
   isValid: ""
}


export const watsons:ReferralData ={
   title: "Watsons Invite Code",
   category: "others,my",
   url: "watsons-invite-code",
   info: "Register Watsons account with Watsons invite code : <b>KdRXiWC05v</b> to get RM7 voucher in your Watsons account after your first online purchase! Watsons is the leading health and beauty retailer with serving the needs of all Malaysians . ...",
   logo: "assets/watson.webp",
   signup: "https://mshare.app.aswatson.com/share/watsons/wtcmy/api/v1.0.0/app/share?type=REGI&refVal=KdRXiWC05v ",
	index:"watsons",
   dateAdded:1635568369,
	tutorial:["assets/tutorial/watsons-invite-code.jpg"],
   isValid: ""
}

export const westMall:ReferralData ={
   title: "West Mall Rewards Referral Code",
   category: "e-wallet,sg,shopping",
   url: "west-mall-rewards-referral-code",
   info: "Use West Mall Rewards referral code <b>eEnGKm</b> in Singapore. The official July 2026 refer-a-friend campaign is marked fully redeemed, so check the app for any live signup voucher, then earn POINTS from eligible S$20 West Mall receipts.",
   logo: "assets/westmall.webp",
   signup: "https://play.google.com/store/apps/details?id=com.alprop.westmall",
	index:"westmall",
   dateAdded:1680410485,
   tutorial:["assets/tutorial/westmallpromo.PNG","assets/tutorial/westmallrefer.PNG","assets/tutorial/westmallpoints.PNG"],
   isValid: ""
}



export const youtrip:ReferralData ={
   title: "YouTrip Referral Code",
   category: "e-wallet,sg",
   url: "youtrip-referral",
   info: "Open our YouTrip invitation link before signup. Both the referred user and referrer receive <b>S$5</b> after completing the referral requirements.",
   logo: "assets/youtrip.webp",
   signup: "https://youtrip.onelink.me/3xWB/bqz7qcp6",
	index:"youtrip",
   dateAdded:1680139669,
   tutorial:["assets/tutorial/youtripCurrency.PNG","assets/tutorial/youtripAcceptance.PNG"],
   isValid: ""
}

export const zcity:ReferralData ={
   title: "Z-City Referral Code",
   category: "others,my",
   url: "zcity-referral-code",
   info: "Register Z-City with Z-City referral code : <b>00DXLN</b> to get 200 reward points and RM3 rebat! Z-City is a cross profit-sharing platform available as an application that allows business owners to promote their product, increase their network,and ...",
   logo: "assets/zcity-referral-code.webp",
   signup: "https://play.google.com/store/apps/details?id=com.zcity.androidapp",
   index:"zcity",
   dateAdded:1615619249,
   isValid: "",
   tutorial:["assets/tutorial/zcity-register.PNG","assets/tutorial/zcity-referral-code.PNG","assets/tutorial/zcity-vouchers-step1.jpg","assets/tutorial/zcity-vouchers-step2.jpg","assets/tutorial/zcity-vouchers-step3.jpg"]
}

export const zus:ReferralData ={
   title: "ZUS Coffee Referral Code",
   category: "others,my",
   url: "zus-coffee-referral-code",
   info: "Register with ZUS Coffee referral code <b>KAH6A4I</b> in the ZUS app to check the current new-user voucher, app rewards, points and limited-time offers.",
   logo: "assets/zus-coffee.webp",
   signup: "https://play.google.com/store/apps/details?id=com.coffee.love_coffee",
   index:"zus",
   dateAdded:1726135102,
   isValid: "",
   tutorial:["assets/tutorial/zus-referral-code.jpg", "assets/tutorial/zus-loyalty.jpg", "assets/tutorial/zus-mission.jpg"]
}
